const ALLOWED = new Set(["P", "BR", "STRONG", "B", "EM", "I", "U", "H2", "H3", "H4", "UL", "OL", "LI", "IMG", "SPAN", "DIV", "A", "FONT"]);
const VOID = new Set(["BR", "IMG"]);
const STYLE_KEEP = /^(font-size|font-family|font-weight|font-style|text-align|text-decoration|color)\s*:/i;

function okSrc(src) {
  const s = String(src || "").trim();
  if (!s || s.length > 2000) return "";
  const low = s.toLowerCase();
  if (low.startsWith("javascript:") || low.startsWith("vbscript:")) return "";
  if (low.startsWith("data:")) return low.startsWith("data:image/") ? s : "";
  if (s.startsWith("/") && !s.startsWith("//")) return s;
  try {
    const u = new URL(s);
    if (u.protocol === "http:" || u.protocol === "https:") return s;
  } catch { /* ignore */ }
  return "";
}

function okHref(href) {
  const s = String(href || "").trim();
  if (!s || s.length > 2000) return "";
  const low = s.toLowerCase();
  if (low.startsWith("javascript:") || low.startsWith("vbscript:") || low.startsWith("data:")) return "";
  if (s.startsWith("/") && !s.startsWith("//")) return s;
  if (s.startsWith("#") || low.startsWith("mailto:") || low.startsWith("tel:")) return s;
  try {
    const u = new URL(s);
    if (u.protocol === "http:" || u.protocol === "https:") return s;
  } catch { /* ignore */ }
  return "";
}

function cleanStyle(raw) {
  return String(raw || "")
    .split(";")
    .map((c) => c.trim())
    .filter((c) => c && STYLE_KEEP.test(c))
    .join("; ")
    .slice(0, 240);
}

export function sanitizeBlogHtml(html) {
  const raw = String(html || "");
  if (!raw) return "";
  if (typeof document === "undefined") return raw;
  const wrap = document.createElement("div");
  wrap.innerHTML = raw;
  const walk = (node) => {
    const kids = [...node.childNodes];
    for (const child of kids) {
      if (child.nodeType === 3) continue;
      if (child.nodeType !== 1) {
        child.remove();
        continue;
      }
      const tag = child.tagName;
      if (!ALLOWED.has(tag)) {
        const frag = document.createDocumentFragment();
        while (child.firstChild) frag.appendChild(child.firstChild);
        child.replaceWith(frag);
        continue;
      }
      const keep = {};
      [...child.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        if (name === "style") {
          const st = cleanStyle(attr.value);
          if (st) keep.style = st;
        } else if (tag === "IMG" && (name === "src" || name === "alt")) {
          keep[name] = attr.value;
        } else if (tag === "A" && name === "href") {
          keep.href = attr.value;
        } else if (tag === "FONT" && (name === "size" || name === "face" || name === "color")) {
          keep[name] = attr.value;
        }
        child.removeAttribute(attr.name);
      });
      if (tag === "IMG") {
        const src = okSrc(keep.src);
        if (!src) {
          child.remove();
          continue;
        }
        child.setAttribute("src", src);
        child.setAttribute("alt", keep.alt || "");
      }
      if (tag === "A") {
        const href = okHref(keep.href);
        if (!href) {
          const frag = document.createDocumentFragment();
          while (child.firstChild) frag.appendChild(child.firstChild);
          child.replaceWith(frag);
          continue;
        }
        child.setAttribute("href", href);
        child.setAttribute("rel", "noopener noreferrer");
        child.setAttribute("target", "_blank");
      }
      if (tag === "FONT") {
        if (keep.size) child.setAttribute("size", keep.size);
        if (keep.face) child.setAttribute("face", keep.face);
        if (keep.color) child.setAttribute("color", keep.color);
      }
      if (keep.style) child.setAttribute("style", keep.style);
      if (!VOID.has(tag)) walk(child);
    }
  };
  walk(wrap);
  return wrap.innerHTML.trim();
}

export function formatBlogDate(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "";
  }
}
